/**
 * Tests
 */
export const SINGLE_TEST_RECEIVED = "SINGLE_TEST_RECEIVED";
export const SET_PROPERTY_TEST = "SET_PROPERTY_TEST";
export const SET_CONTESTADO = "SET_CONTESTADO";
export const TESTS_RECEIVED = "TESTS_RECEIVED";
export const CREATE_TEST = "CREATE_TEST";
